var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Poll(el) {
  var $el = $(el);

  $el.find('.button').on('click', 'a', function(e) {
    e.preventDefault();
    ga('send', {
      hitType: 'event',
      eventCategory: 'Poll',
      eventAction: 'click',
      eventLabel: $el.find('.poll-feature__question').text(),
      eventValue: $(this).text()
    });
    $el.find('.poll-feature__prompt').removeClass('active');
    $el.find('.poll-feature__result').addClass('active');
  });
}

module.exports = Poll;
